import moment from 'moment';
import { PriorityBar, PriorityType } from '@jda/lui-common-component-library';
import View from '@jda/lui-common-icon-library/ui/ViewDetails';
import React from 'react';
import _ from 'lodash';
import { formatString } from '../../utils/helpers';
import { Link } from '@material-ui/core';

const linkStyle = { cursor: 'pointer', textDecoration: 'none' };
const getPriorityStatus: any = (row: any) => {
  if (row?.responseHttpStatus >= 500 && row?.responseHttpStatus <= 599) {
    return PriorityType.CRITICAL;
  } else if (row?.responseHttpStatus >= 400 && row?.responseHttpStatus <= 499) {
    return PriorityType.MEDIUM;
  } else if (row?.retryStatus !== 'COMPLETED' && row?.retryStatus !== null) {
    return PriorityType.DEFAULT;
  } else return PriorityType.LOW;
};

const getEventPriorityStatus: any = (row: any) => {
  if (row.eventStatus === 'Success') return PriorityType.LOW;
  else if (row.eventStatus === 'Failed') return PriorityType.CRITICAL;
  else return PriorityType.MEDIUM;
};
export const getColumns = (classes: any) => {
  return {
    PROVIDER: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Operation',
        field: 'operation',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.operation + (rowData.eventType ? '_' + rowData.eventType : '');
        }
      },
      {
        title: 'Load Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Load Id',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Status',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Aggregator',
        field: 'aggregatorCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Operation',
        field: 'targetOperation',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Service',
        field: 'targetService',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Time',
        field: 'timeTaken',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.timeTaken ? rowData.timeTaken + 'ms' : '';
        }
      },
      {
        title: 'Notification Type',
        field: 'requestType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Description',
        field: 'responseHttpStatus',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.responseHttpStatus + rowData.errorMessage;
        }
      }
    ],

    CUSTOMER: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Operation',
        field: 'operation',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Load Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Load Id',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Status',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Code',
        field: 'providerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Time',
        field: 'timeTaken',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.timeTaken ? rowData.timeTaken + 'ms' : '';
        }
      },
      {
        title: 'Aggregator',
        field: 'aggregatorCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Operation',
        field: 'targetOperation',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Service',
        field: 'targetService',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Notification Type',
        field: 'requestType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Error Description',
        field: 'responseHttpStatus',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.responseHttpStatus + '  ' + rowData.errorMessage;
        }
      }
    ],
    ADMIN: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Operation',
        field: 'operation',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.service === 'freightTracking'
            ? rowData.eventType
            : rowData.operation + (rowData.eventType ? '_' + rowData.eventType : '');
        }
      },
      {
        title: 'Workflow Name',
        field: 'service',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Load Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Load Id',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Status',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Code',
        field: 'providerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Aggregator',
        field: 'aggregatorCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Operation',
        field: 'targetOperation',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Service',
        field: 'targetService',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Time',
        field: 'timeTaken',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.timeTaken ? rowData.timeTaken + 'ms' : '';
        }
      },
      {
        title: 'Notification Type',
        field: 'requestType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Description',
        field: 'responseHttpStatus',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.responseHttpStatus + ' ' + rowData.errorMessage;
        }
      }
    ],

    AGGREGATOR: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Operation',
        field: 'operation',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.operation + (rowData.eventType ? '_' + rowData.eventType : '');
        }
      },
      {
        title: 'Load Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Load Id',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Status',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Code',
        field: 'providerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Operation',
        field: 'targetOperation',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Target Service',
        field: 'targetService',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Response Time',
        field: 'timeTaken',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.timeTaken ? rowData.timeTaken + 'ms' : '';
        }
      },
      {
        title: 'Notification Type',
        field: 'requestType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Description',
        field: 'responseHttpStatus',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => {
          return rowData.responseHttpStatus + rowData.errorMessage;
        }
      }
    ],
    REPLAYRETRY: [
      {
        title: 'Type',
        field: 'type'
      },
      {
        title: 'HTTP Status',
        field: 'httpStatus'
      },
      {
        title: 'Time',
        field: 'retryTime',
        render: (rowData: any) => {
          return rowData?.retryTime ? moment(rowData?.retryTime).format('MM/DD/YYYY hh:mm:ss A') : '';
        }
      }
    ]
  };
};

export default getColumns;

export const getFreightColumns = (classes: any) => {
  return {
    PROVIDER: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Event Type',
        field: 'eventType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Shipment Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Load Number',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Ingestion ID',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      }
    ],

    CUSTOMER: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Event Type',
        field: 'eventType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Shipment Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Load Number',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Ingestion ID',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      }
    ],

    AGGREGATOR: [
      {
        title: 'Priority',
        field: 'priority',
        // Type checking is not handled in material-table
        // This fix will be available soon. It will be removed once fix is available.
        width: 5,
        sorting: false,
        cellStyle: { padding: 8, zIndex: 1 },
        headerStyle: {
          padding: 0
        },
        render: (rowData: any) => {
          return <PriorityBar priority={getPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
        }
      },
      {
        title: 'Event Type',
        field: 'eventType',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Shipment Id',
        field: 'uniqueCustomerTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Load Number',
        field: 'uniqueProviderTransactionId',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Ingestion ID',
        field: 'responseStatus',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Customer Code',
        field: 'customerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Provider Customer Code',
        field: 'providerCustomerCode',
        headerStyle: { zIndex: 11 }
      },
      {
        title: 'Created Time',
        field: 'createdTime',
        headerStyle: { zIndex: 11 },
        render: (rowData: any) => moment(rowData.createdTime).format('MM/DD/YYYY hh:mm:ss A')
      },
      {
        title: 'Status Code',
        field: 'statusCode',
        headerStyle: { zIndex: 11 }
      }
    ]
  };
};

export const ingestionColumns = (classes: any, handleIngestionSpecClick: any) => {
  return [
    // {
    //   title: 'Event Message',
    //   field: 'eventMessage',
    //   headerStyle: { zIndex: 10 },
    //   render: (rowData: any) => {
    //     if (rowData.eventMessage) {
    //       return (
    //         <View
    //           data-id="spec-view"
    //           onClick={() => handleIngestionSpecClick(rowData.eventMessage ? rowData : {})}
    //           style={linkStyle}
    //         />
    //       );
    //     } else return {};
    //   }
    // },
    // {
    //   title: 'Priority',
    //   field: 'priority',
    //   // Type checking is not handled in material-table
    //   // This fix will be available soon. It will be removed once fix is available.
    //   width: 5,
    //   sorting: false,
    //   cellStyle: { padding: 8, zIndex: 1 },
    //   headerStyle: {
    //     padding: 0
    //   },
    //   render: (rowData: any) => {
    //     return <PriorityBar priority={getEventPriorityStatus(rowData)} className={classes.priorityBarSettings} />;
    //   }
    // },

    // {
    //   title: 'Event Category',
    //   field: 'eventCategory',
    //   headerStyle: { zIndex: 11 }
    // },
    // {
    //   title: 'Event Status',
    //   field: 'eventStatus',
    //   headerStyle: { zIndex: 11 }
    // },
    {
      title: 'Ingestion Id',
      field: 'ingestionId',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => (
        <Link onClick={() => handleIngestionSpecClick(rowData)} style={linkStyle}>
          {rowData.ingestionId}
        </Link>
      )
    },
    {
      title: 'Event Time',
      field: 'eventTime',
      headerStyle: { zIndex: 11 },
      render: (rowData: any) => moment(rowData.eventTime, 'YYYY-MM-DD HH:mm:ss:SSS').format('MM/DD/YYYY HH:mm:ss:SSS A')
    }
    // {
    //   title: 'Events Category',
    //   field: 'eventsCategory',
    //   headerStyle: { zIndex: 10 },
    //   render: (rowData: any) => (
    //     <ShowMore lines={2} more="Show more" less="Show less" anchorClass="">
    //       {rowData.eventsCategory}
    //     </ShowMore>
    //   )
    // }
  ];
};

export const EventTypeConfig: any = {
  All: {
    label: 'All',
    value: 'all'
  },
  ExternalPartner: {
    label: 'External Partner Request/Response',
    value: 'ExternalPartnerRequestResponse'
  },
  TrackingMessage: {
    label: 'Tracking message from Partner',
    value: 'TrackingMessagePushedFromPartner'
  },
  MessageToRouter: {
    label: 'Message Sent To Router',
    value: 'SendingEnrichedMessageToRouter'
  },
  IngestionID: {
    label: 'Group By Ingestion ID',
    value: 'ingestionId'
  }
};

export const searchColumns = ['eventType'];
export const subcolumns = (type: any, getJSONStatus: any, handleSpecClick: any) => {
  return [
    {
      title: 'Event Message',
      field: 'eventMessage',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => {
        if (rowData.eventMessage) {
          return (
            <View
              data-id="spec-view"
              onClick={() => handleSpecClick(rowData.eventMessage && !_.isEmpty(rowData.eventMessage) ? rowData : {})}
              style={linkStyle}
            />
          );
        } else {
          return rowData.eventMessage;
        }
      }
    },
    {
      title: 'Event Time',
      field: 'eventTime',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => moment(rowData.eventTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm:ss A')
    },
    type === 'all' && {
      title: 'Event Type',
      field: 'eventType',
      headerStyle: { zIndex: 10 }
    },
    type !== 'all' && {
      title: 'Message Type',
      field: 'eventMessage',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => {
        if (getJSONStatus(rowData.eventMessage)) {
          const messgaeList = formatString(rowData.eventMessage);

          const searchParams = Object.keys(messgaeList).map(key => {
            let msgList: any = '';
            if (key === 'eventMessages') {
              msgList = Object.keys(messgaeList['eventMessages'])
                .map(element => {
                  return messgaeList['eventMessages']?.[element]?.['messageType'];
                })
                .join(',');
            }
            return msgList;
          });
          return searchParams;
        }
      }
    }
  ];
};
